<template>
  <div class="select-equity-container">
    <el-dialog
      class="quick-config-dialog"
      title="快捷配置方案"
      :visible="value"
      width="1300px"
      @close="onClose"
    >
      <div class="quick-config-content new-input-box">
        <jd-tip>
          <div>温馨提示</div>
          <template v-if="cycleMode == 0">
            <div>1.最大时间跨度为12个月，最小为2个月；</div>
            <div>2.活动开始时间为：{{ monthTopTips }}</div>
          </template>
          <template v-if="cycleMode == 1">
            <div>1.最大时间跨度为4个季度，最小为2个季度；</div>
            <div>2.不可向前统计</div>
          </template>
        </jd-tip>
        <el-form ref="ruleForm" label-width="135px">
          <el-form-item label="选择周期玩法：">
            <el-radio-group
              v-model="cycleMode"
              size="small"
              @change="cycleModeChange"
            >
              <div style="padding: 10px 0">
                <el-radio :label="0"
                  >月度玩法
                  <span
                    >按月统计打卡达标条件，每月满足条件则视为打卡成功</span
                  ></el-radio
                >
              </div>
              <div>
                <el-radio :label="1"
                  >季度玩法
                  <span
                    >按季度统计打卡达标条件，每季度满足条件则视为打卡成功</span
                  ></el-radio
                >
              </div>
            </el-radio-group>
          </el-form-item>

          <template v-if="cycleMode == 0">
            <div class="month-box">
              <el-form-item label="首次打卡月份：" required>
                <el-date-picker
                  type="month"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="startTime"
                  placeholder="请选择月份"
                  size="small"
                  :clearable="false"
                  @change="onChangeStartTime"
                  :picker-options="startPickerOptions"
                  style="width: 145px"
                  prefix-icon="none"
                ></el-date-picker>
              </el-form-item>

              <el-form-item label="最后打卡月份：" required>
                <el-date-picker
                  type="month"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="endTime"
                  placeholder="请选择月份"
                  size="small"
                  :clearable="false"
                  @change="onChangeEndTime"
                  :picker-options="endPickerOptions"
                  style="width: 145px"
                  prefix-icon="none"
                ></el-date-picker>
              </el-form-item>
            </div>
          </template>
          <template v-if="cycleMode == 1">
            <el-form-item label="首次打卡季度：" required>
              <quarterPicker
                ref="quarterPicker1"
                :date="startTime"
                :clearable="false"
                @change="handleQuarterPickerChange1"
                placeholder="请选择季度"
                selectedType="1"
                backgroundColor="#F5F5F7"
                :isHasBorder="false"
                :min="ruleForm.startTime"
                style="font-size: 14px; color: #333333"
              />
            </el-form-item>

            <el-form-item label="最后打卡季度：" required>
              <quarterPicker
                ref="quarterPicker2"
                :date="endTime"
                :clearable="false"
                @change="handleQuarterPickerChange2"
                placeholder="请选择季度"
                selectedType="1"
                backgroundColor="#F5F5F7"
                :isHasBorder="false"
                :min="ruleForm.startTime"
                style="font-size: 14px; color: #333333"
              />
            </el-form-item>
          </template>

          <el-form-item label="最大打卡周期：">
            <div>{{ mathMaxCycle() }}</div>
          </el-form-item>

          <el-form-item label="达标条件及奖励：" required>
            <el-radio-group v-model="isSameRule" size="small">
              <el-radio :label="0">每周期相同规则</el-radio>
              <el-radio :label="1"
                >每周期不同规则
                <span>选择不同规则情况下请前往各周期进行设置</span></el-radio
              >
            </el-radio-group>

            <div class="set-box" v-if="isSameRule == 0">
              <el-form-item label="商品要求:" required label-width="115px">
                <el-radio-group
                  v-model="prizeObj.orderWareType"
                  @input="handleChangeCycleOrder()"
                >
                  <el-radio :label="0">全部商品</el-radio>
                  <el-radio :label="1">指定商品</el-radio>
                  <el-radio :label="2">排除商品</el-radio>
                </el-radio-group>
                <jd-button
                  :disabled="prizeObj.orderWareType == 0"
                  style="width: 110px; margin-left: 10px"
                  @click="handleOpenCycleOrderWare()"
                >
                  {{ "已选" + prizeObj.orderWareList.length + "个" }}
                </jd-button>
              </el-form-item>

              <el-form-item label="金额统计类型:" required>
                <el-radio-group
                  v-model="prizeObj.orderPaymentType"
                  :disabled="venderType"
                >
                  <el-radio :label="0">实付金额</el-radio>
                  <el-radio :label="1">订单金额</el-radio>
                </el-radio-group>
                <div style="color: red">
                  <div>1.注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。</div>
                  <div>2.订单金额是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。</div>
                </div>
              </el-form-item>

              <el-form-item label="打卡达标条件:" required label-width="115px">
                <el-radio-group v-model="prizeObj.checkInConditionType">
                  <el-radio :label="0">单一条件</el-radio>
                  <el-radio :label="1">组合条件</el-radio>
                </el-radio-group>

                <div class="check-conditon-box">
                  <template v-if="prizeObj.checkInConditionType == 0">
                    <el-form-item>
                      <el-radio
                        :label="0"
                        v-model="prizeObj.singleConditionType"
                      >
                        <span class="mr-r-6">消费满</span>
                        <el-input
                          v-model="prizeObj.orderAmountThreshold"
                          placeholder="请输入"
                          style="width: 100px"
                          @input="
                            prizeObj.orderAmountThreshold = getLimit(
                              $event,
                              1,
                              999999,
                              1
                            )
                          "
                        ></el-input>
                        <span class="margin-left-6">元</span>
                      </el-radio>
                    </el-form-item>
                    <el-form-item>
                      <el-radio
                        :label="1"
                        v-model="prizeObj.singleConditionType"
                      >
                        <span class="mr-r-6">消费满</span>
                        <el-input
                          v-model="prizeObj.itemNumThreshold"
                          placeholder="请输入"
                          style="width: 100px"
                          @input="
                            prizeObj.itemNumThreshold = getLimit(
                              $event,
                              0,
                              999999,
                              1
                            )
                          "
                        ></el-input>
                        <span class="margin-left-6">件</span>
                      </el-radio>
                    </el-form-item>
                    <el-form-item>
                      <el-radio
                        :label="2"
                        v-model="prizeObj.singleConditionType"
                      >
                        <span class="mr-r-6">消费满</span>
                        <el-input
                          v-model="prizeObj.orderNumThreshold"
                          placeholder="请输入"
                          style="width: 100px"
                          @input="
                            prizeObj.orderNumThreshold = getLimit(
                              $event,
                              0,
                              999999,
                              1
                            )
                          "
                        ></el-input>
                        <span class="margin-left-6">笔</span>
                      </el-radio>
                    </el-form-item>
                  </template>

                  <el-form-item v-if="prizeObj.checkInConditionType == 1">
                    <el-radio-group
                      v-model="prizeObj.combinationConditionMode"
                      class="mb-20"
                    >
                      <el-radio :label="0">需满足全部条件才算达标</el-radio>
                      <el-radio :label="1">满足任一条件即算达标</el-radio>
                    </el-radio-group>
                    <el-checkbox-group v-model="prizeObj.combinationTypeCheck">
                      <el-form-item>
                        <el-checkbox :label="0">
                          <span class="mr-r-6">消费满</span>
                          <el-input
                            v-model="prizeObj.orderAmountThreshold"
                            placeholder="请输入"
                            style="width: 100px"
                            @input="
                              prizeObj.orderAmountThreshold = getLimit(
                                $event,
                                1,
                                999999,
                                1
                              )
                            "
                          ></el-input>
                          <span class="margin-left-6">元</span>
                        </el-checkbox>
                      </el-form-item>
                      <el-form-item>
                        <el-checkbox :label="1">
                          <span class="mr-r-6">消费满</span>
                          <el-input
                            v-model="prizeObj.itemNumThreshold"
                            placeholder="请输入"
                            style="width: 100px"
                            @input="
                              prizeObj.itemNumThreshold = getLimit(
                                $event,
                                0,
                                999999,
                                1
                              )
                            "
                          ></el-input>
                          <span class="margin-left-6">件</span>
                        </el-checkbox>
                      </el-form-item>
                      <el-form-item>
                        <el-checkbox :label="2">
                          <span class="mr-r-6">消费满</span>
                          <el-input
                            v-model="prizeObj.orderNumThreshold"
                            placeholder="请输入"
                            style="width: 100px"
                            @input="
                              prizeObj.orderNumThreshold = getLimit(
                                $event,
                                0,
                                999999,
                                1
                              )
                            "
                          ></el-input>
                          <span class="margin-left-6">笔</span>
                        </el-checkbox>
                      </el-form-item>
                    </el-checkbox-group>
                  </el-form-item>
                </div>
              </el-form-item>

              <el-form-item label="奖品设置:" required label-width="115px">
                <div style="max-width: 1100px">
                  <jd-button
                    type="blue"
                    v-if="prizeObj.settingList.length < 10"
                    @click="addSetting()"
                    style="margin-bottom: 12px"
                    class="mr-r-6"
                    >添加奖品{{ prizeObj.settingList.length }}/10</jd-button
                  >
                  <!-- <jd-tip color="text">周期奖励和累积奖励必填一项</jd-tip> -->
                  <el-table
                    :data="prizeObj.settingList"
                    style="border: 1px solid #eeeeee"
                    :header-cell-style="{
                      background: '#fafafa',
                      'text-align': 'left',
                    }"
                  >
                    <el-table-column label="奖品类型" align="center">
                      <template slot-scope="scope">
                        <span v-if="scope.row.prizeType == 1">优惠券</span>
                        <span v-if="scope.row.prizeType == 2">京豆</span>
                        <span v-if="scope.row.prizeType == 3">实物</span>
                        <span v-if="scope.row.prizeType == 4">店铺积分</span>
                        <span v-if="scope.row.prizeType == 5">京东E卡</span>
                        <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                        <span v-if="scope.row.prizeType == 7"
                          >京东PLUS会员</span
                        >
                        <span v-if="scope.row.prizeType == 8">现金红包</span>
                        <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                        <span v-if="scope.row.prizeType == 10">礼品卡</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="奖品价值"
                      width="100"
                      prop="price"
                      align="center"
                    ></el-table-column>
                    <el-table-column label="奖品名称（15字内）" width="270">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.title"
                          maxlength="15"
                          :disabled="scope.row.prizeType == 4"
                          show-word-limit
                          style="width: 230px"
                          placeholder="请输入"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="奖品数量" width="150">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.totalAmount"
                          @input="
                            scope.row.totalAmount = getNumberData(
                              1,
                              $event,
                              0,
                              1,
                              999999
                            )
                          "
                          class="inputcount"
                          style="width: 120px"
                          placeholder="请输入"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="图片" width="150">
                      <template slot-scope="scope">
                        <img
                          v-if="scope.row.logo"
                          :src="scope.row.logo"
                          style="width: 50px; height: 50px"
                          disabled
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="180">
                      <template slot-scope="scope">
                        <jd-button type="blueText" @click="centerVis2(scope)"
                          >选择奖品</jd-button
                        >
                        <jd-button
                          v-if="prizeObj.settingList.length > 1"
                          type="blueText"
                          @click="itemDel(scope.$index)"
                          >删除</jd-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-form-item>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <jd-button @click="onClose">取消</jd-button>
        <jd-button type="break" @click="comfirm">生成周期方案</jd-button>
      </span>

      <!-- 周期-指定购买商品 -->
      <selectGoodsMonitor
        ref="selectGoFilter"
        :isShow="selectGoodsStateFilter"
        @close="handleCycleOrderWareClose"
        :selectGoods="itemListForFilter"
        :moduleType="true"
        :skuSearch="true"
        :xianz="true"
        :isSku="true"
      ></selectGoodsMonitor>

      <select-Product
        ref="selectProduct2"
        v-if="showSelectProduct"
        :echoDate="echoDate2"
        :num="1"
        :actId="valueRow"
        :JingdouCount="JingdouCount"
        :typeDefault="typeDefault"
        @choose-shop="getTheData2"
      ></select-Product>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 快捷配置方案
 */
import quarterPicker from "@/views/BI/analysis/components/quarter-range-picker/index.vue";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import selectProduct from "@/views/interactiveMarketing/activity/select_product.vue";
import moment from "moment";
export default {
  name: "QuickConfig",
  components: {
    quarterPicker,
    selectGoodsMonitor,
    selectProduct,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    defaultStartTime: {
      type: String,
      default: "",
    },
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    valueRow: {
      type: Object,
      default: () => ({}),
    },
    JingdouCount: {
      type: Object,
      default: () => ({}),
    },
    typeDefault: {
      type: Object,
      default: () => ({}),
    },
    venderType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cycleMode: 0, // 周期玩法 0-月度 1-季度
      startTime: "", // 首次打卡月份
      endTime: "", // 最后打卡月份
      startPickerOptions: {
        disabledDate: (time) => this.disabledDate(time, "start"),
      },
      endPickerOptions: {
        disabledDate: (time) => this.disabledDate(time, "end"),
      },
      isSameRule: 0, // 周期相同规则
      prizeObj: {
        orderWareType: 0, // 商品要求类型
        orderWareList: [], // 商品要求
        orderPaymentType: this.venderType ? 1 : 0, //金额统计类型
        checkInConditionType: 0, // 打卡达标条件
        combinationConditionMode: 0, // 组合类型
        orderAmountThreshold: "", // 消费金额
        orderNumThreshold: "", // 消费笔数
        itemNumThreshold: "", // 消费件数
        singleConditionType: 0, // 单一条件
        combinationTypeCheck: [],
        settingList: [
          {
            index: 0,
            prizeType: null,
            price: null,
            logo: null,
            title: "",
            totalAmount: null,
          },
        ],
      },

      itemListForFilter: [], //指定商品列表
      selectGoodsStateFilter: false, //指定购买商品弹窗
      tableIndex: 0,
      echoDate2: {},
      showSelectProduct: false,

      defaultLogo: "https://cdn-image.yucrm.cn/hd/images/prizeShow646.png",
    };
  },
  computed: {
    selectFoodsEndTime() {
      let time = "";
      if (this.cycleMode == 0) {
        time = this.endTime;
      } else if (this.cycleMode == 1) {
        // 获取最后一个周期的结束时间
        time = this.getCycleRange(this.endTime, 0, true, 1);
      }
      return time;
    },
    monthTopTips() {
      let tips = "";
      if (this.ruleForm.startTime) {
        let year = this.ruleForm.startTime.substring(0, 4);
        let month = Number(this.ruleForm.startTime.substring(5, 7));
        let day = Number(this.ruleForm.startTime.substring(8, 10));
        let lastMonth = month - 1 <= 0 ? 12 + month - 1 : month - 1;
        let lastMonth2 = month - 2 <= 0 ? 12 + month - 2 : month - 2;
        tips = `${year}年${month}月${day}日，可向前选择2个月，即首次打卡月份可选${lastMonth2}月${lastMonth}月`;
      } else {
        tips = "还未选择活动开始时间";
      }
      return tips;
    },
  },
  watch: {
    value(val) {
      console.log("isShow", val);
      if (val) {
        this.startTime = this.defaultStartTime;
      } else {
        this.cycleMode = 0; // 周期玩法 0-月度 1-季度
        this.startTime = ""; // 首次打卡月份
        this.endTime = ""; // 最后打卡月份
        this.isSameRule = 0; // 周期相同规则
        this.prizeObj = {
          orderWareType: 0, // 商品要求类型
          orderWareList: [], // 商品要求
          orderPaymentType: this.venderType ? 1 : 0, //金额统计类型
          checkInConditionType: 0, // 打卡达标条件
          combinationConditionMode: 0, // 组合类型
          orderAmountThreshold: "", // 消费金额
          orderNumThreshold: "", // 消费笔数
          itemNumThreshold: "", // 消费件数
          singleConditionType: 0, // 单一条件
          combinationTypeCheck: [],
          settingList: [
            {
              index: 0,
              prizeType: null,
              price: null,
              logo: null,
              title: "",
              totalAmount: null,
            },
          ],
        };

        this.itemListForFilter = []; //指定商品列表
        this.tableIndex = 0;
        this.echoDate2 = {};
      }
    },
  },
  methods: {
    // 选择奖品同外面活动一致
    handleChangeCycleOrder() {
      this.prizeObj.orderWareList = [];
      this.itemListForFilter = [];
    },
    addSetting() {
      if (this.prizeObj.settingList.length >= 10)
        return this.$message.warning("最多只能设置10个奖品");
      this.prizeObj.sortIndex = this.prizeObj.sortIndex + 1;
      this.prizeObj.settingList.push({
        index: this.prizeObj.sortIndex,
        prizeType: null,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
      });
    },
    itemDel(index) {
      this.prizeObj.sortIndex -= 1;
      this.prizeObj.settingList.splice(index, 1);
    },
    getTheData2(data, prizeType) {
      let index = this.tableIndex;
      if (prizeType == 1) {
        this.prizeObj.settingList[index].couponType = data.couponType;
      }
      if (data.giftType) {
        this.prizeObj.settingList[index].giftType = Number(data.giftType);
      }
      this.prizeObj.settingList[index].price = Number(data.discount);

      this.prizeObj.settingList[index].assetsId = Number(data.couponId || data.skuId);
      this.prizeObj.settingList[index].logo = data.logo || this.defaultLogo;
      this.prizeObj.settingList[index].prizeType = prizeType;
      this.prizeObj.settingList[index].title = data.name;
      if (prizeType == 4) {
        this.prizeObj.settingList[index].title = data.discount + "店铺积分";
      } else {
        this.prizeObj.settingList[index].title = data.name;
      }

      if (data.singleAmount) {
        this.prizeObj.settingList[index].singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        this.prizeObj.settingList[index].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          this.prizeObj.settingList[index].skuId = data.skuId;
          delete this.prizeObj.settingList[index].isGoodManage;
        } else {
          this.prizeObj.settingList[index].isGoodManage = data.isGoodManage;
        }
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.prizeObj.settingList[index].budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        this.prizeObj.settingList[index].budgetRemain = data.budgetRemain;
      }
      this.showSelectProduct = false;
    },
    centerVis2(scope) {
      this.tableIndex = scope.$index;
      this.echoDate2 = scope.row;
      this.showSelectProduct = true;
      this.$nextTick(() => {
        this.$refs.selectProduct2.openDialog();
      });
    },
    // 周期-商品选择弹窗控制
    handleOpenCycleOrderWare() {
      this.selectGoodsStateFilter = true;
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.prizeObj.orderWareList = [];
      } else {
        this.itemListForFilter = this.prizeObj.orderWareList;
      }
      this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },
    handleCycleOrderWareClose(data) {
      if (data) {
        this.itemListForFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          fomeVaule.wareId = data[index].wareId;
          this.itemListForFilter.push(fomeVaule);
        });
        this.prizeObj.orderWareList = this.itemListForFilter;
      }
      this.selectGoodsStateFilter = false;
    },
    // 计算最大周期
    mathMaxCycle() {
      if (this.startTime && this.endTime) {
        if (this.cycleMode == 1) {
          const startQuarter = this.getQuarterTag(this.startTime);
          const endQuarter = this.getQuarterTag(this.endTime);

          // 解析季度数值
          const [startYear, startQ] = startQuarter.split("-Q");
          const [endYear, endQ] = endQuarter.split("-Q");

          // 计算季度跨度
          const totalQuarters = (endYear - startYear) * 4 + (endQ - startQ);

          return totalQuarters + 1;
        } else if (this.cycleMode == 0) {
          const refDate = new Date(this.startTime);
          const current = new Date(this.endTime);
          // 修正月份差计算方式：当前时间应早于参考时间（对于开始时间）且不超过12个月
          const monthDiff =
            (current.getFullYear() - refDate.getFullYear()) * 12 +
            current.getMonth() -
            refDate.getMonth();
          return monthDiff + 1;
        }
      }
      return "";
    },
    // 切换玩法类型重置
    cycleModeChange() {
      this.startTime = this.defaultStartTime;
      this.endTime = "";
    },
    getQuarterTag(dateStr) {
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      return `${year}-Q${Math.ceil(month / 3)}`;
    },
    handleQuarterPickerChange1(date) {
      if (!date) return;

      // 当已选择结束季度且新开始季度 > 结束季度时，清空结束季度
      if (this.endTime) {
        const startQuarter = this.getQuarterTag(date);
        const endQuarter = this.getQuarterTag(this.endTime);

        // 解析季度数值
        const [startYear, startQ] = startQuarter.split("-Q");
        const [endYear, endQ] = endQuarter.split("-Q");

        // 计算季度跨度
        const totalQuarters = (endYear - startYear) * 4 + (endQ - startQ);

        // 校验顺序
        if (endQuarter < startQuarter) {
          this.endTime = "";
          this.$message.warning("最后打卡季度不能早于首次打卡季度");
          return;
        }

        // 校验跨度（最大4个季度）
        if (totalQuarters > 3) {
          // 0表示同一季度，3表示跨度4个季度
          this.endTime = "";
          this.$message.warning("打卡月份最大时间跨度为4个季度");
          return;
        }
      }
      this.startTime = date;
    },
    handleQuarterPickerChange2(date) {
      if (!date) return;

      // 当已选择开始季度且新结束季度 < 开始季度时，清空开始季度
      if (this.startTime) {
        const startQuarter = this.getQuarterTag(this.startTime);
        const endQuarter = this.getQuarterTag(date);

        // 解析季度数值
        const [startYear, startQ] = startQuarter.split("-Q");
        const [endYear, endQ] = endQuarter.split("-Q");

        // 计算季度跨度
        const totalQuarters = (endYear - startYear) * 4 + (endQ - startQ);

        // 校验顺序
        if (endQuarter < startQuarter) {
          this.$refs.quarterPicker2.clearCurrentDate();
          this.$message.warning("最后打卡季度不能早于首次打卡季度");
          return;
        }

        // 校验跨度（最大4个季度）
        if (totalQuarters > 3) {
          // 0表示同一季度，3表示跨度4个季度
          this.$refs.quarterPicker2.clearCurrentDate();
          this.$message.warning("打卡月份最大时间跨度为4个季度");
          return;
        }
      }
      this.endTime = date;
    },
    disabledDate(time, type) {
      const currentDate = new Date(this.ruleForm.startTime);
      const twoMonthsAgo = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 2,
        1
      );
      const current = new Date(time);

      // 处理未选择结束时间时的开始时间限制（仅禁止早于两个月前）
      if (type === "start" && !this.endTime) {
        return current < twoMonthsAgo; // 仅保留早于两个月前的限制
      }

      const reference = type === "start" ? this.endTime : this.startTime;
      if (!reference) return false;

      const refDate = new Date(reference);
      const monthDiff =
        (current.getFullYear() - refDate.getFullYear()) * 12 +
        current.getMonth() -
        refDate.getMonth();

      if (type === "start") {
        return current > refDate || Math.abs(monthDiff) >= 12;
      } else {
        return current < refDate || monthDiff >= 12;
      }
    },
    onChangeStartTime() {
      if (this.endTime && new Date(this.startTime) >= new Date(this.endTime)) {
        this.endTime = "";
        this.$message.warning("最后打卡月份需晚于首次打卡月份");
      }
    },
    onChangeEndTime() {
      if (
        this.startTime &&
        new Date(this.endTime) <= new Date(this.startTime)
      ) {
        this.startTime = "";
        this.$message.warning("最后打卡月份需晚于首次打卡月份");
      }
    },
    comfirm() {
      if (!this.startTime) return this.$message.warning("请选择首次打卡月份");
      if (!this.endTime) return this.$message.warning("请选择最后打卡月份");
      if (this.isSameRule == 0) {
        if (
          this.prizeObj.orderWareType >= 1 &&
          this.prizeObj.orderWareList.length == 0
        ) {
          return this.$message.warning(
            `请勾选${this.prizeObj.orderWareType == 1 ? "指定" : "排除"}商品~`
          );
        }
        if (this.prizeObj.checkInConditionType == 0) {
          if (
            (this.prizeObj.singleConditionType == 0 &&
              !this.prizeObj.orderAmountThreshold) ||
            (this.prizeObj.singleConditionType == 1 &&
              !this.prizeObj.itemNumThreshold) ||
            (this.prizeObj.singleConditionType == 2 &&
              !this.prizeObj.orderNumThreshold)
          ) {
            return this.$message.warning("请完善打卡达标条件");
          }
        } else if (this.prizeObj.checkInConditionType == 1) {
          if (
            this.prizeObj.combinationTypeCheck.length == 0 ||
            (this.prizeObj.combinationTypeCheck.includes(0) &&
              !this.prizeObj.orderAmountThreshold) ||
            (this.prizeObj.combinationTypeCheck.includes(1) &&
              !this.prizeObj.itemNumThreshold) ||
            (this.prizeObj.combinationTypeCheck.includes(2) &&
              !this.prizeObj.orderNumThreshold)
          ) {
            return this.$message.warning("请完善打卡达标条件");
          }
        }
        if (this.prizeObj.settingList.length == 0) {
          return this.$message.warning("请添加奖品");
        }
        let isNull = false;
        this.prizeObj.settingList.forEach((item) => {
          if (!item.totalAmount || !item.title) {
            isNull = true;
          }
        });
        if (isNull) {
          return this.$message.warning("请将奖品填写完整");
        }
      }
      let maxCycle = this.mathMaxCycle();
      let { cycleMode, startTime, endTime, isSameRule, prizeObj } = this;

      let cycleArr = [];
      for (let i = 0; i < maxCycle; i++) {
        const startDate = this.getCycleRange(startTime, i, false, cycleMode);
        const endDate = this.getCycleRange(startTime, i, true, cycleMode);

        let item = {
          sortIndex: 0,
          cycleName: "",
          cycleStartTime: startDate,
          cycleEndTime: endDate,
          orderWareType: 0, // 商品要求类型
          orderWareList: [], // 商品要求
          orderPaymentType: this.venderType ? 1 : 0, //金额统计类型
          checkInConditionType: 0, // 打卡达标条件
          combinationConditionMode: 0, // 组合类型
          orderAmountThreshold: "", // 消费金额
          orderNumThreshold: "", // 消费笔数
          itemNumThreshold: "", // 消费件数
          singleConditionType: 0, // 单一条件
          combinationTypeCheck: [],
          settingList: [
            {
              index: 0,
              prizeType: null,
              price: null,
              logo: null,
              title: "",
              totalAmount: null,
            },
          ],
        };
        // 如果是相同规则，就直接赋值
        if (isSameRule == 0) {
          for (let key in prizeObj) {
            item[key] = prizeObj[key];
          }
        }
        cycleArr.push(item);
      }
      this.$emit("comfirm", JSON.parse(JSON.stringify(cycleArr)));
      this.$emit("input", false); // 关闭弹窗
    },
    onClose() {
      this.$emit("input", false);
    },
    getCycleRange(dateStr, cycleIndex, isEnd = false, cycleMode) {
      const date = new Date(dateStr);
      let year = date.getFullYear();
      let month = date.getMonth() + 1; // 转换为1-12月

      if (cycleMode == 0) {
        // 月度玩法
        const cycleMonth = month + cycleIndex;
        const startMonth = cycleMonth % 12 || 12;
        const startYear = year + Math.floor((cycleMonth - 1) / 12);

        const startDate = new Date(startYear, startMonth - 1, 1);
        const endDate = new Date(startYear, startMonth, 0);
        endDate.setHours(23, 59, 59, 0);

        return isEnd
          ? moment(endDate).format("YYYY-MM-DD HH:mm:ss")
          : moment(startDate).format("YYYY-MM-DD HH:mm:ss");
      } else {
        // 季度玩法
        const startQ = Math.ceil(month / 3); // 原始季度(1-4)
        const totalQuarters = startQ + cycleIndex; // 总季度数

        // 计算年份偏移量和当前季度
        const yearOffset = Math.floor((totalQuarters - 1) / 4);
        const currentQuarter = ((totalQuarters - 1) % 4) + 1;

        const startYear = year + yearOffset;
        const startMonth = (currentQuarter - 1) * 3; // 季度起始月份(0-based)
        const endMonth = startMonth + 3;

        const startDate = new Date(startYear, startMonth, 1);
        const endDate = new Date(startYear, endMonth, 0);
        endDate.setHours(23, 59, 59, 0);

        return isEnd
          ? moment(endDate).format("YYYY-MM-DD HH:mm:ss")
          : moment(startDate).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    // 格式化时间
    formatTime(date) {
      const pad = (n) => n.toString().padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} 
        ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  padding: 20px 24px !important;
}
.set-box {
  // background: #f8f9fc;
  padding: 20px 20px 20px 0;
  border-radius: 4px;
  border: 1px solid #eeeeee;
}
.mr-r-6 {
  margin-right: 6px;
}
.check-conditon-box {
  width: 580px;
  // background: #f8f9fc;
  border: 2px solid #f8f9fc;
  padding: 20px 20px 5px 20px;
  border-radius: 4px;
}
.mb-20 {
  margin-bottom: 20px;
}

.month-box {
  /deep/ .el-input--small .el-input__inner {
    padding-left: 5px !important;
  }
}
.margin-left-6 {
  margin-left: 6px;
}
</style>
